var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetlifyNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 113,
    viewBox: "0 0 129 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4595 74.6047H71.6825L70.9494 73.8717V53.3259C70.9494 49.6705 69.513 46.8372 65.1047 46.7382C62.8361 46.6787 60.2406 46.7382 57.4669 46.8471L57.0508 47.2731V55.5746V73.8618L56.3177 74.5948H47.5407L46.8076 73.8618V38.7636L47.5407 38.0305H67.294C74.9714 38.0305 81.1926 44.2517 81.1926 51.9291V73.8717L80.4595 74.6047Z",
    fill: "#014847"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5931 94.0509H33.3845L27.3516 88.0179V86.8094L36.5744 77.5866H42.964L43.8159 78.4385V84.8281L34.5931 94.0509Z",
    fill: "#05BDBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3516 25.816V24.6074L33.3845 18.5744H34.5931L43.8159 27.7972V34.1868L42.964 35.0388H36.5744L27.3516 25.816Z",
    fill: "#05BDBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8412 61.4491H0.73307L0 60.716V51.9192L0.73307 51.1861H35.8412L36.5743 51.9192V60.716L35.8412 61.4491Z",
    fill: "#05BDBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.277 61.4491H92.1686L91.4355 60.716V51.9192L92.1686 51.1861H127.277L128.01 51.9192V60.716L127.277 61.4491Z",
    fill: "#05BDBA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9429 27.0642V0.73307L59.6759 0H68.4728L69.2059 0.73307V27.0642L68.4728 27.7972H59.6759L58.9429 27.0642Z",
    fill: "#05BDBA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9429 111.902V85.5711L59.6759 84.838H68.4728L69.2059 85.5711V111.902L68.4728 112.635H59.6759L58.9429 111.902Z",
    fill: "#05BDBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlifyNew);
export default __webpack_public_path__ + "static/media/netlify-new.33f939ac4bf30ee04cdbe0dc4634b9a8.svg";
export { ForwardRef as ReactComponent };